<y42-list-view
  name="Data test jobs"
  searchLabel="Search"
  [hideQuickFilters]="false"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [frameworkComponents]="frameworkComponents"
  (gridReady)="gridReady($event)"
  [canAdd]="false"
  [hideLoader]="true"
  [defaultQuickFilters]="defaultQuickFilters"
  [hideSearchWhenNoData]="false"
  [messages]="messages"
>
  <ng-container y42ListViewSearchFields>
    <y42-refresh-jobs-button class="mr-2"></y42-refresh-jobs-button>
    <mat-form-field class="w-1/2 no-padding pr-2" appearance="outline">
      <mat-label>Date range</mat-label>
      <mat-date-range-input
        [formGroup]="selectedDateRangeForm"
        [rangePicker]="picker"
        [max]="max"
        class="text-gray-1100"
      >
        <input matStartDate placeholder="Start date" [formControl]="selectedDateRangeForm.controls.from" />
        <input matEndDate placeholder="End date" [formControl]="selectedDateRangeForm.controls.to" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </ng-container>
</y42-list-view>
